import { useState } from "react";

export function useToggle(initial: boolean): [boolean, (val?: boolean) => void] {
  const [value, setValue] = useState(initial);

  const toggle = (val = !value) => {
    setValue(val)
  }

  return [value, toggle]
}

export default useToggle;